var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 27,
    viewBox: "0 0 45 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0729 21.27L41.8599 3.59348C41.941 3.48938 41.9363 3.34215 41.8486 3.2435C41.7356 3.11644 41.5353 3.12214 41.4298 3.25541L28.0417 20.1562C25.726 23.0795 21.3327 23.2044 18.8547 20.4175L3.5742 3.232C3.46441 3.10851 3.27144 3.10851 3.16165 3.232C3.06926 3.3359 3.06857 3.49229 3.16004 3.597L18.8231 21.5273C21.3027 24.3659 25.7548 24.2421 28.0729 21.27Z",
    stroke: "#1B3C68",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownItem);
export default __webpack_public_path__ + "static/media/dropdown-item.93d72df541cb347ede9565beac067545.svg";
export { ForwardRef as ReactComponent };